import { Box, Typography, useTheme } from "@mui/material";
import { PimoReactComponent } from "@pimo/pimo-app-builder";

type SectionHeaderProps = {
  title: string;
};

export const AINTSectionHeader: PimoReactComponent<SectionHeaderProps> = ({
  title,
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.primary.contrastText,
        p: 1,
      }}
    >
      <Typography variant="h5">{title}</Typography>
    </Box>
  );
};
